// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SyMWk","footer":"styles_footer__1GkK1","passCodeTooltip":"styles_passCodeTooltip__1RbBA"};